import React, { Component } from 'react';
import { HandleMessage } from '../../../HandleMessage';

export class DefaultRules extends Component {
    render() {
        const { model } = this.props;

        return (
            <HandleMessage
                title="Aviso"
                message={`O Produto ${model.name} não tem configurações disponíveis para o Tipo de Tarifário associado`}
                style={`warning`}
                icon="alert"
                show={true}
                onHide={() => this.props.onExit()} />
        );
    }
}
